import React from 'react';
import 'twin.macro';

export const Table = ({ children, caption, ...restProps }) => (
  <>
    <table
      tw='
    w-full
    table-auto
    rounded-lg
    text-sm
'
      {...restProps}
    >
      {caption && <caption tw='caption-top opacity-60 mb-2'>{caption}</caption>}
      {children}
    </table>
  </>
);
